import { createSlice } from '@reduxjs/toolkit';

export const viewListingSlice = createSlice({
  name: 'viewListing',
  initialState: {
    id: null,
    title: null,
    introduction: null,
    price: null,
    area: null,
    pricingOption: null,
    sellingOption: null,
    bounds: null,
    landParcels: [],
    images: [],
    treeSegmentationTiles: [],
    treeSegmentationTilesTotalCount: 0,
    unsegmentedTiles: [],
    chmTiles: [],
    taskModalDialogVisible: false
  },
  reducers: {
    setListing: (state, action) => {
      const {
        id,
        title,
        introduction,
        price,
        area,
        tasks,
        pricingOption,
        sellingOption,
        bounds,
        landParcels,
        images
      } = action.payload;
      state.id = id;
      state.title = title;
      state.introduction = introduction;
      state.price = price;
      state.area = area;
      state.tasks = tasks;
      state.pricingOption = pricingOption;
      state.sellingOption = sellingOption;
      state.bounds = bounds;
      state.landParcels = landParcels;
      state.images = images?.items ?? [];
    },
    setTreeSegmentationTiles: (state, action) => {
      state.treeSegmentationTiles = action.payload;
    },
    setTreeSegmentationTilesTotalCount: (state, action) => {
      state.treeSegmentationTilesTotalCount = action.payload;
    },
    setUnsegmentedTiles: (state, action) => {
      state.unsegmentedTiles = action.payload;
    },
    setCHMTiles: (state, action) => {
      state.chmTiles = action.payload;
    },
    setTaskModalDialogVisible: (state, action) => {
      state.taskModalDialogVisible = action.payload;
    }
  }
});

export const {
  setListing,
  setTreeSegmentationTiles,
  setTreeSegmentationTilesTotalCount,
  setUnsegmentedTiles,
  setCHMTiles,
  setTaskModalDialogVisible
} = viewListingSlice.actions;
export default viewListingSlice.reducer;
